// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__3UKLc","consentsList":"PatientConsents_consentsList__Rwzui","consentsListEmpty":"PatientConsents_consentsListEmpty__2V1fp"};